﻿import css from './booking-link.scss?inline';

// The host supplies a localized label and a destination; this widget owns no tenant state.
export class BookingLink extends HTMLElement {
    static get observedAttributes() {
        return ['href', 'label'];
    }

    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        const style = document.createElement('style');
        style.textContent = css;
        this.link = document.createElement('a');
        shadow.append(style, this.link);
    }

    connectedCallback() {
        this.render();
    }

    attributeChangedCallback() {
        this.render();
    }

    render() {
        const label = (this.getAttribute('label') || '').trim();
        const href = (this.getAttribute('href') || '').trim();
        let destination;
        try {
            // Relative links are resolved on the embedding site, not the script's origin.
            destination = href ? new URL(href, this.ownerDocument.baseURI) : null;
        } catch (error) {
            destination = null;
        }

        const valid = label && destination &&
            (destination.protocol === 'https:' || destination.protocol === 'http:');
        this.link.textContent = label;
        this.link.hidden = !valid;
        if (valid) {
            this.link.href = destination.href;
        } else {
            this.link.removeAttribute('href');
        }
    }
}

export function registerBookingLink() {
    // Multiple script imports and subsequently inserted instances are safe.
    if (!customElements.get('bookhus-booking-link')) {
        customElements.define('bookhus-booking-link', BookingLink);
    }
}
